import React from 'react'
import { Link } from 'react-router-dom';

function Feature() {
  const gototop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
  return (
    <>
      <section>
        <div className="container">
          <div
            className="row justify-content-between align-items-center mb-4 mb-lg-5"
          >
            <div className="col-lg-6 col-md-5">
              <div>
                <h2>
                  <span className="font-w-4 d-block me-2">Effortless Process in</span>
                  Three Simple Steps
                </h2>
              </div>
            </div>
            {/* <div class="col-lg-4 col-12 text-center">              
              <Link className="btn btn-dark" to="quotation">Order Your Inspection</Link>
            </div> */}
          </div>
          <div className="row mt-lg-n5 align-items-center">
            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div className="p-5 feature-hover active position-relative">
                <div className="f-icon">
                  <img src={require("../../assets/icon/ord.webp")} width={60} alt="Order Inspection" loading='lazy' />
                </div>
                <h5 className="mt-4 mb-3">Order Inspection</h5>
                <p className="mb-0">
                  You can easily place an inspection order through our website or by calling our team to complete it over the phone.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div className="p-5 feature-hover active position-relative">
                <div className="f-icon">
                  <img src={require("../../assets/icon/insp.webp")} width={60} alt="Expert Inspection Process" loading='lazy' />
                </div>
                <h5 className="mt-4 mb-3">Expert Inspection Process</h5>
                <p className="mb-0">
                  Our ASE certified inspector contacts your seller, arranges an inspection appointment, and performs a comprehensive on-site examination.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div className="p-5 feature-hover active position-relative">
                <div className="f-icon">
                  <img src={require("../../assets/icon/acc.webp")} width={60} alt="Access Your Report" loading='lazy' />
                </div>
                <h5 className="mt-4 mb-3">Access Your Report</h5>
                <p className="mb-0">
                  The inspector completes the report on-site. After a thorough review and error checking process, you’ll receive an email with a link to access your report.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}

export default Feature
